<template>
  <v-container fluid fill-height grid-list-md text-xs-center>
    <v-layout wrap align-center justify-center fill-height>
      <v-flex xs12 md3>
        <v-layout justify-center class="pa-3">
          <v-img :src="this.logoUrl" width="200"></v-img>
        </v-layout>
      </v-flex>

      <v-flex xs12 md3>
        <h1>{{ $t('resendConfirmationEmail') }}</h1>
        <v-form @submit.prevent="submit">
          <v-text-field v-model="email" :label="$t('attrs.email')" required></v-text-field>
          <v-btn block color="primary" :loading="loading" type="submit">{{ $t('send') }}</v-btn>

          <a @click="goTo('login')">{{ $t('login') }}</a>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Session from '@/client/session'

export default {
  name: 'ConfirmationView',

  data () {
    return {
      loading: false,
      email: ''
    }
  },

  methods: {
    async submit () {
      this.errors.clear()

      this.loading = true
      try {
        await Session.sendConfirmationEmail(this.email)
        this.setNotification({ color: 'info', message: this.$t('confirmationSendNotification') })
        this.goTo('login')
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    }
  }
}
</script>
